module.exports = __webpack_public_path__ + "img/gym.085d81dd.svg";